// Tiny shared helpers for the board review's hand-rolled SVG charts.

export function scaleLinear([d0, d1], [r0, r1]) {
  const d = d1 - d0 || 1;
  const s = (v) => r0 + ((v - d0) / d) * (r1 - r0);
  s.invert = (r) => d0 + ((r - r0) / (r1 - r0)) * d;
  return s;
}

// Clean tick values covering [min, max].
export function niceTicks(min, max, count = 5) {
  const span = max - min || 1;
  const step0 = span / count;
  const mag = Math.pow(10, Math.floor(Math.log10(step0)));
  const norm = step0 / mag;
  const step = (norm >= 5 ? 10 : norm >= 2 ? 5 : norm >= 1 ? 2 : 1) * mag;
  const start = Math.ceil(min / step) * step;
  const ticks = [];
  for (let v = start; v <= max + 1e-9; v += step) ticks.push(Math.round(v / step) * step);
  return ticks;
}

export function linePath(points) {
  return points.map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join('');
}

export function areaBetween(upper, lower) {
  const back = [...lower].reverse();
  return (
    upper.map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join('') +
    back.map((p) => `L${p[0].toFixed(1)},${p[1].toFixed(1)}`).join('') +
    'Z'
  );
}
